import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[text-columns-image-overlay-carousel]',
  swiperWrapper: '[data-swiper-wrapper]',
};

const classes = {
  swiperWrapper: 'swiper-wrapper',
  swiperPagination: '.swiper-pagination',
};

class TextColumnsImageOverlay extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.breakpoint = window.matchMedia('(min-width:1024px)');

      this.carouselWrappers = document.querySelector(selectors.carouselWrapper);

      this.swiperWrapper = this.carouselWrappers.querySelector(
        selectors.swiperWrapper
      );

      this.initCarousels();

      // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
      // If not, it will get destroyed.
      this.registerEventListeners();
    });
  }

  initCarousels() {
    if (this.carousel) {
      // Clean up the swiper object for re-initialisation.
      this.carousel.destroy();
      this.swiperWrapper.classList.remove(classes.swiperWrapper);
    }

    if (this.breakpoint.matches === false) {
      // Only add the wrapper class if the breakpoints initialise and we need to create the swiper.
      this.swiperWrapper.classList.add(classes.swiperWrapper);

      this.carousel = new Swiper(selectors.carouselWrapper, {
        modules: [Navigation, Pagination],
        freeMode: true,
        slidesPerView: 2.7,
        spaceBetween: 40,
        watchOverflow: true,
        pagination: {
          el: classes.swiperPagination,
        },
      });
    }
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.initCarousels();
    });
  }
}

customElements.define('text-columns-image-overlay', TextColumnsImageOverlay);
